/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, June 1st 2022, 6:12:51 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useNavigate } from "react-router-dom";
import { URLS } from "core/routes";
import { OSActionButton, FullScreenNotificationGrid } from "ui-widgets";
import { ClipBoard2Icon } from "theme/icons";

export const ContinueSetupCTA = ({ organizationName }) => {
  const navigate = useNavigate();

  return (
    <FullScreenNotificationGrid
      pageTitle={
        <>
          <b>{organizationName}</b> is incomplete.
        </>
      }
      pageContent={
        <>
          <p>
            We still need some more information to fully onboard your organization to Onestop. Kindly continue setting
            up details about {organizationName}.
          </p>
          <p>
            <OSActionButton variant="contained" onClick={() => navigate(URLS.setup)} size="large">
              Continue Setup
            </OSActionButton>
          </p>
        </>
      }
      pageIllustration={<ClipBoard2Icon height={256} width={256} />}
    />
  );
};
